import * as actionsType from "../actions/types";

const initialState = {};

export default function productDetailsReducer(state=initialState, action) {
    switch(action.type) {
        case actionsType.SET_PRODUCT_DETAILS:
            const {details} = action.payload;
            return {...state, details}
        default:
            return state;
    }
}